import { render, staticRenderFns } from "./StudentFeeDepositeDialog.vue?vue&type=template&id=5c2c4498"
import script from "./StudentFeeDepositeDialog.vue?vue&type=script&lang=js"
export * from "./StudentFeeDepositeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports